import {
  defineGuide
} from "./chunk-K5HMTNL7.js";

// src/assets.ts
var ASSET_KEYS = [
  "shared/module-willie.png",
  "shared/connecter-emetteur-antenne.png",
  "shared/module-fixe-au-mur.jpg",
  // Reached through `EFENTO_ASSETS` in `variants.ts` rather than by any guide: the housing differs,
  // the install does not, so a guide names the gesture and the variant decides whose box is in frame.
  "shared/module-willie-efento.jpg",
  "shared/module-fixe-au-mur-efento.jpg",
  "shared/photo-globale-efento.jpg",
  "shared/alignement-emetteur-dessous.png",
  "shared/alignement-emetteur-profil.png",
  "shared/alignement-emetteur-face.png",
  "shared/index-compteur.png",
  "shared/photo-globale.png",
  "shared/emetteur-cyble-v2.png",
  "shared/emetteur-diehl-izar.png",
  // One file for both Diehl guides: the gesture photographed is the same emitter on the same fitting,
  // and it shipped as two byte-identical copies under `izar/` and `diehl-dock/` before the port.
  "shared/emetteur-diehl-clipse.png",
  "cyble/emetteur-cyble-sensor.png",
  "cyble/retrait-bouchon.jpg",
  "cyble/positionnement-emetteur.jpg",
  "cyble/fixation-vis.jpg",
  "itron-aquadis/retrait-vis-plastique.jpg",
  "itron-flodis/retrait-vis-plastique.jpg",
  "itron-flodis/retrait-piece-plastique.jpg",
  "itron-flostar/retrait-vis-plastique.jpg",
  "cyble-dock/itron-dock.png",
  "cyble-dock/step-1-avant.png",
  "cyble-dock/step-1-apres.png",
  "cyble-dock/step-4-fixer-module-willie.png",
  "diehl-dock/diehl-dock.png",
  "diehl-dock/step-1-avant.png",
  "diehl-dock/step-1-apres.jpg",
  "diehl-dock/step-4-fixer-module-willie.jpg",
  "b-meter-pl3/emetteur-iwm-pl3.png",
  "b-meter-pl3/step-1-retirer-autocollant.png",
  "b-meter-pl3/step-2-emboiter-1.png",
  "b-meter-pl3/step-2-emboiter-2.png",
  "b-meter-pl3/step-2-emboiter-3.png",
  "b-meter-pl4/emetteur-iwm-pl4.png",
  "b-meter-pl4/step-1-retirer-autocollant.png",
  "b-meter-pl4/step-2-emboiter.png",
  "b-meter-pl4/step-3-vis-autocollant.png",
  "cgr-5502/emetteur-cgr.png",
  "cgr-5502/step-1.png",
  "cgr-5502/step-2.png",
  "cgr-5502/step-3.png",
  "cgr-5505/emetteur-cgr.png",
  "cgr-5505/step-1.png",
  "cgr-5505/step-2.png",
  "cgr-5505/step-2-face.png",
  "cgr-5507/emetteur-cgr.png",
  "cgr-5507/step-1.png",
  "datalogger-only/boite-jonction.png",
  "kamstrup-pulse-adapter/adaptateur.png",
  "kamstrup-pulse-adapter/montage-adaptateur.jpg",
  "kamstrup-pulse-adapter/activation-sortie-impulsion.jpg",
  "maddalena-flowpulse-wmap-evo/emetteur-flowpulse.png",
  "maddalena-flowpulse-wmap-evo/step-1-positionner.png",
  "maddalena-flowpulse-wmap-evo/step-2-crochet-vis.png",
  "maddalena-flowpulse-wmap-evo/step-3-sceller.png",
  "maddalena-flowpulse-mvm/step-1-positionner.png",
  "maddalena-flowpulse-mvm/step-2-crochet-vis.png",
  "maddalena-flowpulse-mvm/step-2-deux-vis.png",
  "maddalena-reed-one/emetteur-maddalena.png",
  "maddalena-reed-one/step-1.png",
  "maddalena-reed-one/step-2.png",
  "maddalena-reed-sjplus/emetteur-reed.jpg",
  "maddalena-reed-sjplus/sceau-adhesif.jpg",
  "maddalena-reed-sjplus/step-1-retirer-obturateur.jpg",
  "maddalena-reed-sjplus/step-2-inserer.jpg",
  "maddalena-reed-sjplus/step-2-enfoncer.jpg",
  "maddalena-reed-sjplus/step-3-sceller.jpg",
  "maddalena-reed-sjplus/resultat.jpg",
  "maddalena-reed-wmap/emetteur-reed.png",
  "maddalena-reed-wmap/step-1.png",
  "maddalena-reed-wmap/step-2.png",
  "maddalena-reed-wmap/step-3.png",
  "maddalena-reed-wmap/step-4.png",
  "octave-arad/module-arad.jpg",
  "octave-arad/step-2-bouchon-vis.png",
  "octave-arad/step-4-joint-torique.png",
  "octave-arad/step-5-fixer-module.png",
  "octave-arad/step-6-bouchon.png",
  "ot-metric/duplicateur.jpg",
  "sensus-hri/emetteur-hri.jpg",
  "sensus-hri/step-1.jpg",
  "sensus-hri/step-2.jpg",
  "sensus-hri/step-3-alignement.jpg",
  "sensus-hri/step-3-verrouillage.jpg",
  "sensus-hri/step-4.jpg",
  "sensus-hri/step-5.jpg",
  "sensus-hri/step-6.jpg",
  "sensus-hri-mei/emetteur-hri-mei.png",
  "sensus-hri-mei/retrait-capot.png",
  "sensus-hri-mei/ouverture-capot-lateral.png",
  "sensus-hri-mei/rotation-bague.png",
  "sensus-hri-mei/retrait-film-protection.png",
  "sensus-hri-mei/pose-emetteur.png",
  "sensus-hri-mei/verrouillage-bague.png",
  "zenner-edc-s/module-edc-s.png",
  "zenner-edc-s/pose-edc-s.png",
  "zenner-mtk/anneau-impulsion-seul.png",
  "zenner-mtk/anneau-impulsion.png",
  "zenner-multipulse/valeur-impulsion.png",
  "zenner-reed-woltman/emetteur-reed.jpg",
  "zenner-reed-woltman/positions-cadran.png",
  "zenner-reed-woltman/step-1-plombage.png",
  "zenner-reed-woltman/step-2-vis-capot.png",
  "zenner-reed-woltman/step-3-inserer-emetteur.png",
  "zenner-reed-woltman/step-4-passe-cable.png",
  "zenner-reed-woltman/step-5-remonter-capot.png",
  "zenner-reed-woltman/step-6-sceller-capot.png",
  // One file for the component shot and for the tear-off step: the manual's only PR6-alone render is
  // the one carrying the tear-off arrow.
  "elster-pr6-v200/emetteur-pr6.png",
  "elster-pr6-v200/step-2-charniere.png",
  "elster-pr6-v200/step-3-emboiter.png",
  "elster-pr6-v200/step-4-tiges.png",
  "elster-pr6-v200/step-4-vis-scelles.png",
  "elster-pr6-v200/step-5-autocollants.png",
  "debimetre-eh/sortie-impulsion.png",
  "debimetre-eh/totalisateur.jpg",
  "debimetre-eh-ot-metric/valeur-impulsion.png",
  "debimetre-eh-ot-metric/debitmetre-ouvert.png",
  "debimetre-eh-ot-metric/sortie-impulsion-raccordee.png",
  "debimetre-eh-ot-metric/duplicateur-entree-sorties.png",
  "debimetre-eh-ot-metric/reconnexion-equipement-existant.png",
  "debimetre-eh-ot-metric/raccordement-entree.png",
  "debimetre-krohne/totalisateur.png",
  "isma-dlk-102/dlk-102.png",
  "krohne-ifc100-otmetric/menu-setup.png",
  "krohne-ifc100-otmetric/menu-sortie-impulsion.png",
  "krohne-ifc100-otmetric/frequence-impulsion-max.jpg",
  "krohne-ifc100-otmetric/valeur-impulsion.png",
  "krohne-ifc100-otmetric/polarite-impulsion.jpg",
  "krohne-ifc100-otmetric/coupure-bas-debit.jpg",
  "krohne-ifc100-otmetric/enregistrer-configuration.jpg",
  "krohne-ifc100/debitmetre-ouvert.jpg",
  "krohne-ifc100/sortie-impulsion.jpg",
  "krohne-ifc100/bornes-sortie-impulsion.jpg",
  "krohne-ifc100-otmetric/debitmetre-ferme.png",
  "krohne-ifc100-otmetric/installation-terminee.png",
  "krohne-ifc100-otmetric/module-fixe.png",
  "krohne-ifc100-otmetric/sortie-libre.png",
  "krohne-ifc100-otmetric/debitmetre-ouvert.png",
  "krohne-ifc100-otmetric/sortie-impulsion-raccordee.png",
  "debimetre-eh-promag-30/couvercle-raccordement.jpg",
  "debimetre-eh-promag-30/bornier.jpg",
  "debimetre-eh-promag-30/raccordement-module.jpg",
  "debimetre-eh-promag-30/couvercle-raccordement-ferme.jpg",
  "debimetre-eh-promag-30/totalisateur.jpg",
  "debimetre-eh-promag-30/couvercle-afficheur-ouvert.jpg",
  "debimetre-eh-promag-30/menu-surface.jpg",
  "debimetre-eh-promag-30/menu-unite-volume.jpg",
  "debimetre-eh-promag-30/valeur-impulsion.jpg",
  "debimetre-eh-promag-30/installation-terminee.jpg",
  "siemens-fmt020/totalisateur.jpg",
  "siemens-fmt020/bornes-sortie-impulsion.png",
  "diehl-hydrus/compteur-hydrus.png",
  "diehl-hydrus/raccordement-module.png",
  "diehl-hydrus/ecran-volume-total.png"
];

// src/reading.ts
var READING_MAX_DIGITS = 15;
var SEPARATOR = ",";
var TYPED = /^(\d+)(?:[.,](\d*))?$/;
var GROUPERS = /\s/g;
var formatReading = ({ raw, decimalDigits }) => {
  if (decimalDigits === 0) return raw;
  const padded = raw.padStart(decimalDigits + 1, "0");
  const split = padded.length - decimalDigits;
  return `${padded.slice(0, split)}${SEPARATOR}${padded.slice(split)}`;
};
var readingValue = ({ raw, decimalDigits }) => Number(raw) / 10 ** decimalDigits;
var parseReading = (typed) => {
  const matched = TYPED.exec(typed.replace(GROUPERS, ""));
  if (!matched) return { ok: false, failure: "not-a-number" };
  const [, whole = "", fraction = ""] = matched;
  const raw = `${whole}${fraction}`;
  if (raw.length > READING_MAX_DIGITS) return { ok: false, failure: "too-long" };
  return { ok: true, digits: { raw, decimalDigits: fraction.length } };
};
var isCorrection = (confirmed, transcribed) => transcribed !== null && readingValue(confirmed) !== readingValue(transcribed);
var indexCaptureOf = (guide) => guide.steps.find((step) => step.capture?.kind === "meter_index" && (step.capture.gate?.readings.length ?? 0) > 0)?.capture;

// src/rich-text.ts
var PATTERN = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https:\/\/[^\s)]+)\)/g;
var parseRichText = (source) => {
  const tokens = [];
  let cursor = 0;
  for (const match of source.matchAll(PATTERN)) {
    const [raw, bold, linkText, href] = match;
    if (match.index > cursor) tokens.push({ text: source.slice(cursor, match.index) });
    if (bold !== void 0) tokens.push({ text: bold, bold: true });
    else tokens.push({ text: linkText, href });
    cursor = match.index + raw.length;
  }
  if (cursor < source.length) tokens.push({ text: source.slice(cursor) });
  return tokens;
};

// src/strings.ts
var MissingGuideStringError = class extends Error {
  constructor(key) {
    super(`No prose for guide key "${key}"`);
    this.key = key;
    this.name = "MissingGuideStringError";
  }
};
var makeGuideStrings = (table) => {
  const text = (key) => {
    const value = table[key];
    if (value === void 0) throw new MissingGuideStringError(key);
    return value;
  };
  return { text, rich: (key) => parseRichText(text(key)), has: (key) => table[key] !== void 0 };
};
var flattenStrings = (source, prefix = "") => {
  if (typeof source === "string") return { [prefix]: source };
  if (source === null || typeof source !== "object" || Array.isArray(source)) return {};
  return Object.entries(source).reduce(
    (flat, [key, value]) => Object.assign(flat, flattenStrings(value, prefix ? `${prefix}.${key}` : key)),
    {}
  );
};

// src/variants.ts
var VARIANT_BY_MAKER = {
  shayp: "default",
  efento: "efento",
  adeunis: "default",
  other: "default"
};
var loggerVariant = (maker) => maker ? VARIANT_BY_MAKER[maker] : "default";
var loggerVariantForMaker = (maker) => maker !== null && maker !== void 0 && maker in VARIANT_BY_MAKER ? VARIANT_BY_MAKER[maker] : "default";
var EFENTO_DROPPED_PHOTOS = /* @__PURE__ */ new Set(["shared/connecter-emetteur-antenne.png"]);
var EFENTO_DROPPED_CHECKS = /* @__PURE__ */ new Set([
  "datalogger-only.verification.antenna",
  "debimetre-eh.verification.antenna",
  "zenner-multipulse.verification.antenna"
]);
var EFENTO_ASSETS = {
  "shared/module-willie.png": "shared/module-willie-efento.jpg",
  "shared/module-fixe-au-mur.jpg": "shared/module-fixe-au-mur-efento.jpg",
  "shared/photo-globale.png": "shared/photo-globale-efento.jpg",
  "cyble-dock/step-4-fixer-module-willie.png": "shared/module-fixe-au-mur-efento.jpg",
  "diehl-dock/step-4-fixer-module-willie.jpg": "shared/module-fixe-au-mur-efento.jpg"
};
var swapAsset = (item) => ({
  ...item,
  asset: EFENTO_ASSETS[item.asset] ?? item.asset
});
var swapBlock = (block) => {
  if (block.type !== "photos") return [block.type === "diagram" ? swapAsset(block) : block];
  const items = block.items.filter((photo) => !EFENTO_DROPPED_PHOTOS.has(photo.asset)).map(swapAsset);
  return items.length > 0 ? [{ ...block, items }] : [];
};
var swapPrereqs = (prereqs) => prereqs.kind === "before-after" ? { ...prereqs, before: swapAsset(prereqs.before), after: swapAsset(prereqs.after) } : prereqs;
var appliesTo = (step, variant) => step.loggers === void 0 || step.loggers.includes(variant);
var applyLoggerVariant = (guide, slug, variant) => {
  if (variant !== "efento") return guide;
  return {
    ...guide,
    components: guide.components.map(swapAsset),
    prereqs: swapPrereqs(guide.prereqs),
    steps: guide.steps.filter((step) => appliesTo(step, variant)).map((step) => ({ ...step, body: step.body.flatMap(swapBlock) })),
    verification: guide.verification.filter((check) => !EFENTO_DROPPED_CHECKS.has(`${slug}.${check}`))
  };
};

// src/locales/fr/shared.json
var shared_default = {
  connectAntenna: {
    title: "Connecter et installer l'antenne du module Willie",
    body: "Branchez le c\xE2ble de l'\xE9metteur d'impulsion sur le module Willie, puis vissez l'antenne sur l'emplacement pr\xE9vu du module.",
    photo: {
      alt: "Connexion du c\xE2ble de l'\xE9metteur d'impulsion au module Willie et installation de l'antenne",
      caption: "Branchement du c\xE2ble de l'\xE9metteur sur le module Willie et vissage de l'antenne"
    }
  },
  connectAntennaFlowmeter: {
    body: "Branchez le c\xE2ble raccord\xE9 \xE0 la sortie impulsion sur le module Willie, puis vissez l'antenne sur l'emplacement pr\xE9vu du module."
  },
  fixModule: {
    title: "Fixer le module Willie",
    body: "Une fois l'\xE9metteur d'impulsion install\xE9, fixer le module Willie pour \xE9viter toute casse et en hauteur pour s'assurer de la force du signal.",
    tip: "**Astuce :** Il y a un emplacement d\xE9di\xE9 sous le module Willie afin de le fixer \xE0 un endroit solide.",
    photo: {
      alt: "Exemple d'installation termin\xE9e \u2014 module Willie fix\xE9 au mur",
      caption: "Exemple d'installation termin\xE9e \u2014 le module Willie (\xE0 gauche) est fix\xE9 au mur, \xE0 l'abri de l'eau."
    }
  },
  fixModuleFlowmeter: {
    body: "Une fois le raccordement effectu\xE9, fixer le module Willie pour \xE9viter toute casse et en hauteur pour s'assurer de la force du signal."
  },
  readTotalizer: {
    title: "Photographier le volume total",
    body: "Sur l'\xE9cran du d\xE9bitm\xE8tre, relevez le **volume total** \u2014 le volume d'eau mesur\xE9 depuis l'installation du d\xE9bitm\xE8tre, en m\xB3 ou en litres. Ne le remettez jamais \xE0 z\xE9ro : cette valeur est le point de d\xE9part des consommations remont\xE9es sur la plateforme Willie.",
    capture: "Photographiez l'\xE9cran du d\xE9bitm\xE8tre montrant le volume total.",
    photo: {
      alt: "\xC9cran d'un d\xE9bitm\xE8tre Endress+Hauser : le d\xE9bit instantan\xE9 en m\xB3/h sur la premi\xE8re ligne, le volume total en m\xB3 sur la seconde.",
      caption: "Exemple \u2014 relevez le volume en m\xB3, pas le d\xE9bit en m\xB3/h."
    },
    gate: {
      displayInFrame: {
        claim: "L'\xE9cran du d\xE9bitm\xE8tre est visible dans le cadre.",
        fix: "Cadrez l'\xE9cran du d\xE9bitm\xE8tre."
      },
      showsTotalizer: {
        claim: "L'\xE9cran affiche le totalisateur : un volume cumul\xE9, en m\xB3 ou en litres. Un d\xE9bit instantan\xE9 (m\xB3/h, l/s\u2026) affich\xE9 seul ne suffit pas ; affich\xE9 \xE0 c\xF4t\xE9 du totalisateur, il ne g\xEAne pas.",
        fix: "Affichez le volume total \xE0 l'\xE9cran, puis reprenez la photo."
      },
      digitsLegible: {
        claim: "Tous les chiffres du totalisateur se lisent avec certitude. Les reflets, la bu\xE9e et la salet\xE9 sur la vitre ne comptent que s'ils emp\xEAchent vraiment d'identifier un chiffre.",
        fix: "Refaites la photo de plus pr\xE8s, appareil bien stable, sans reflet sur l'\xE9cran."
      },
      index: {
        label: "Volume total"
      }
    }
  },
  alignment: {
    title: "V\xE9rifier l'alignement de l'\xE9metteur",
    warning: "**V\xE9rifiez l'alignement :** l'\xE9metteur doit \xEAtre pos\xE9 bien \xE0 plat et enti\xE8rement clips\xE9 sur la t\xEAte du compteur \u2014 ni inclin\xE9, ni d\xE9centr\xE9. Un \xE9metteur mal align\xE9 fausse la lecture des impulsions.",
    intro: "**Alignement correct** \u2014 pour compter correctement les impulsions, l'\xE9metteur doit \xEAtre positionn\xE9 pr\xE9cis\xE9ment au-dessus de l'index du compteur. Trois points \xE0 v\xE9rifier :",
    orientation: "**Orientation** \u2014 le pied de l'\xE9metteur est d\xE9tromp\xE9 et ne s'embo\xEEte que dans un seul sens. Alignez le rep\xE8re de l'\xE9metteur avec le rep\xE8re de r\xE9f\xE9rence du compteur afin que la zone de d\xE9tection se trouve directement au-dessus de l'index rotatif du compteur.",
    seating: "**Embo\xEEtement** \u2014 appuyez sur l'\xE9metteur bien \xE0 plat sur le compteur jusqu'\xE0 ce qu'il soit enti\xE8rement embo\xEEt\xE9. Sur la vue de profil, la bague de base grise doit \xEAtre plaqu\xE9e contre la t\xEAte du compteur, sans jeu ni inclinaison.",
    locking: "**Verrouillage** \u2014 enclenchez le clip pour que l'\xE9metteur ne puisse ni tourner ni se soulever. Un \xE9metteur mal enclench\xE9 ou \xE0 moiti\xE9 embo\xEEt\xE9 manquera des impulsions ou comptera par intermittence.",
    photos: {
      above: {
        alt: "\xC9metteur Cyble Sensor V2 correctement centr\xE9 sur la t\xEAte du compteur, vu de dessus",
        caption: "Vue de dessus \u2014 l'\xE9metteur est centr\xE9 sur la t\xEAte du compteur."
      },
      profile: {
        alt: "\xC9metteur Cyble Sensor V2 reposant bien \xE0 plat sur le compteur, vu de profil",
        caption: "De profil \u2014 l'\xE9metteur repose bien \xE0 plat, sans inclinaison."
      },
      front: {
        alt: "\xC9metteur Cyble Sensor V2 dont la base est enti\xE8rement clips\xE9e sur le compteur, vu de face",
        caption: "De face \u2014 la base est enti\xE8rement clips\xE9e, sans jeu."
      }
    },
    capture: "Prenez une photo de l'\xE9metteur clips\xE9 sur la t\xEAte du compteur."
  },
  moduleWillie: {
    name: "Module Willie",
    alt: "Module Willie (datalogger) avec antenne"
  },
  identification: {
    lead: "Familiarisez-vous avec les \xE9l\xE9ments fournis avant de d\xE9marrer l'installation."
  },
  prereqs: {
    supplied: "Fourni dans le kit",
    bring: "\xC0 pr\xE9voir",
    optional: "Optionnel"
  },
  photographIndex: {
    title: "Photographier l'index du compteur",
    body: "Photographiez l'index du compteur d'eau, d'assez pr\xE8s pour que chaque chiffre soit lisible \u2014 y compris les cadrans rouges.",
    capture: "Prenez la photo de l'index.",
    photo: {
      alt: "Exemple : photo de l'index du compteur d'eau"
    },
    gate: {
      dialInFrame: {
        claim: "Le cadran chiffr\xE9 du compteur d'eau est visible dans le cadre.",
        fix: "Cadrez le cadran chiffr\xE9 du compteur."
      },
      digitsLegible: {
        claim: "Les chiffres des m\xE8tres cubes entiers \u2014 ceux \xE0 gauche des chiffres rouges \u2014 se lisent avec certitude. La salet\xE9, les rayures, l'ombre, les reflets et une face us\xE9e sont l'ordinaire d'un compteur : ils ne comptent que s'ils emp\xEAchent vraiment d'identifier un chiffre.",
        fix: "Refaites la photo de plus pr\xE8s, appareil bien stable, chiffres nets."
      },
      wholeRegister: {
        claim: "Tous les chiffres des m\xE8tres cubes entiers apparaissent dans la photo. Un chiffre ne manque que s'il sort du cadre : les chiffres rouges d\xE9cimaux partiellement couverts par le module, son collier ou le bo\xEEtier sont l'\xE9tat normal d'un compteur \xE9quip\xE9 et ne manquent pas.",
        fix: "Reculez un peu : il manque un chiffre au bord de la photo."
      },
      index: {
        label: "Index du compteur"
      }
    }
  },
  photographInstallation: {
    title: "Photographier l'installation termin\xE9e",
    body: "Une derni\xE8re photo d'ensemble, montrant le compteur et l'antenne dans le m\xEAme cadre.",
    capture: "Prenez la photo d'ensemble.",
    photo: {
      alt: "Exemple : photo globale de l'installation"
    }
  },
  photographInstallationFlowmeter: {
    body: "Une derni\xE8re photo d'ensemble, montrant le d\xE9bitm\xE8tre et l'antenne dans le m\xEAme cadre."
  },
  sections: {
    components: "Composants",
    compatibility: "Compatibilit\xE9",
    prereqs: "Avant de commencer",
    steps: "\xC9tapes",
    verification: "V\xE9rification finale",
    identification: "Identification du mat\xE9riel"
  },
  critical: "Important",
  plate: {
    steps: "\xC9tapes",
    photos: "Photos \xE0 envoyer",
    components: "Composants"
  },
  cybleSensor: {
    removeScrew: {
      title: "Retirer la vis plastique du compteur",
      body: "Sous l'index du compteur, rep\xE9rez la **vis plastique** \xE0 fente qui prot\xE8ge l'emplacement de d\xE9tection. D\xE9vissez-la \xE0 l'aide d'un tournevis plat et retirez-la \u2014 c'est l\xE0 que l'\xE9metteur Cyble Sensor viendra se fixer.",
      warning: "**Attention :** Il est possible que la vis ait d\xE9j\xE0 \xE9t\xE9 retir\xE9e. Si l'emplacement est d\xE9j\xE0 libre, passez directement \xE0 l'\xE9tape suivante sans forcer sur le compteur."
    },
    fix: {
      title: "Fixer l'\xE9metteur Cyble Sensor avec la vis",
      body: "Positionnez l'\xE9metteur Cyble Sensor sur l'emplacement de d\xE9tection du compteur. Fixez-le \xE0 l'aide de la **vis de fixation**. Serrez fermement mais sans forcer.",
      activation: "**Activation automatique :** Le bouton-poussoir situ\xE9 sous l'\xE9metteur Cyble Sensor s'active automatiquement lors de l'installation. Aucune manipulation suppl\xE9mentaire n'est n\xE9cessaire pour le mettre en marche.",
      video: "**Vid\xE9o d'aide :** Cette \xE9tape est illustr\xE9e en vid\xE9o ici : [voir la vid\xE9o](https://youtu.be/3lyAmiWZybc?t=58)",
      photos: {
        placing: {
          alt: "Positionnement de l'\xE9metteur Cyble Sensor sur le compteur",
          caption: "Positionnement de l'\xE9metteur Cyble Sensor sur le compteur"
        },
        screw: {
          alt: "Fixation avec la vis de fixation",
          caption: "Fixation avec la vis sur le dessus du bo\xEEtier"
        }
      }
    }
  }
};

// src/locales/fr/efento.json
var efento_default = {
  shared: {
    fixModule: {
      tip: "**Astuce :** Le module Willie dispose de pattes de fixation perc\xE9es \xE0 sa base, pour le visser sur un support solide."
    },
    photographInstallation: {
      body: "Une derni\xE8re photo d'ensemble, montrant le compteur et le module Willie dans le m\xEAme cadre."
    },
    photographInstallationFlowmeter: {
      body: "Une derni\xE8re photo d'ensemble, montrant le d\xE9bitm\xE8tre et le module Willie dans le m\xEAme cadre."
    }
  },
  "abb-few630": {
    verification: {
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "abb-fxe4000": {
    verification: {
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "fuji-modmag": {
    verification: {
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "isma-dlk-102": {
    steps: {
      wireModule: {
        body: "D\xE9vissez le capot inf\xE9rieur du DLK pour acc\xE9der au bornier. Les sorties relais sont rep\xE9r\xE9es **SN1** \xE0 **SN4** sur la carte, chacune sur deux bornes. Faites passer le c\xE2ble du module Willie par un presse-\xE9toupe libre sous le bo\xEEtier, puis raccordez-le au tournevis plat sur les deux bornes de la sortie retenue. Seuls deux fils sont \xE0 raccorder :",
        wires: {
          positive: "Le fil **brun** sur la premi\xE8re borne de la sortie relais.",
          negative: "Le fil **blanc** sur la seconde borne de la m\xEAme sortie relais."
        },
        unused: "Si le c\xE2ble du module Willie comporte d'autres fils, laissez-les isol\xE9s, sans les raccorder."
      }
    },
    verification: {
      wired: "Le fil brun et le fil blanc sont raccord\xE9s sur les deux bornes de la m\xEAme sortie relais, le presse-\xE9toupe est serr\xE9 et le capot du bornier reviss\xE9.",
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "siemens-mag-5000-6000": {
    verification: {
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "siemens-fmt020": {
    steps: {
      wireModule: {
        body: "Le c\xE2ble du module Willie comporte plusieurs fils : deux d'entre eux se raccordent sur les deux bornes de la sortie num\xE9rique, **DO_C** et **DO_\u2212**. \xC0 l'aide d'un petit tournevis plat :",
        actions: {
          positive: "Raccordez le fil **brun** sur la borne **DO_C (+)**.",
          negative: "Raccordez le fil **blanc** sur la borne **DO_\u2212 (\u2212)**."
        },
        unused: "Si le c\xE2ble du module Willie comporte d'autres fils, laissez-les isol\xE9s, sans les raccorder."
      }
    },
    verification: {
      terminals: "Le c\xE2ble du module Willie est raccord\xE9 sur la sortie num\xE9rique (brun sur DO_C, blanc sur DO_\u2212) et rien n'est raccord\xE9 sur DO_+.",
      mounted: "Le module Willie est fix\xE9 solidement et en hauteur."
    }
  },
  "zenner-mtk": {
    verification: {
      cable: "Le c\xE2ble de l'anneau est branch\xE9 sur le module Willie."
    }
  },
  "cyble-dock": {
    steps: {
      fixModule: {
        photo: {
          alt: "Exemple d'installation termin\xE9e \u2014 module Willie fix\xE9 au mur",
          caption: "Exemple d'installation termin\xE9e \u2014 le module Willie (\xE0 gauche) est fix\xE9 au mur, \xE0 l'abri de l'eau."
        }
      }
    },
    verification: {
      willie: "Le c\xE2ble de l'\xE9metteur d'impulsion est branch\xE9 sur le module Willie et le module est fix\xE9 en hauteur."
    }
  },
  "diehl-dock": {
    steps: {
      fixModule: {
        photo: {
          alt: "Exemple d'installation termin\xE9e \u2014 module Willie fix\xE9 au mur",
          caption: "Exemple d'installation termin\xE9e \u2014 le module Willie (\xE0 gauche) est fix\xE9 au mur, \xE0 l'abri de l'eau."
        }
      }
    },
    verification: {
      willie: "Le c\xE2ble de l'\xE9metteur d'impulsion est branch\xE9 sur le module Willie et le module est fix\xE9 en hauteur."
    }
  },
  "ot-metric": {
    steps: {
      wireOutputTwo: {
        title: "Brancher SORTIE 2 sur le module Willie",
        body: "Branchez le c\xE2ble de la seconde sortie (**SORTIE 2**) du duplicateur sur l'entr\xE9e du module Willie."
      }
    }
  },
  "debimetre-eh-ot-metric": {
    steps: {
      wireOutputTwo: {
        title: "Brancher le c\xE2ble noir sur le module Willie",
        body: "Branchez le **c\xE2ble noir**, d\xE9j\xE0 reli\xE9 \xE0 la **sortie Willie** du duplicateur, sur l'entr\xE9e du module Willie."
      }
    }
  },
  "krohne-ifc100-otmetric": {
    steps: {
      wireOutputTwo: {
        title: "Brancher le c\xE2ble noir sur le module Willie",
        body: "Branchez le **c\xE2ble noir**, d\xE9j\xE0 reli\xE9 \xE0 la **sortie Willie** du duplicateur, sur l'entr\xE9e du module Willie."
      }
    }
  }
};

// src/registry.ts
var GUIDE_MODULES = {
  "abb-few630": {
    structure: () => import("./structure-XFE6KUOO.js"),
    locales: { fr: () => import("./fr-RRAMSGF3.js") }
  },
  "abb-fxe4000": {
    structure: () => import("./structure-M2TG7UXC.js"),
    locales: { fr: () => import("./fr-CKLJ3LQZ.js") }
  },
  "b-meter-pl3": {
    structure: () => import("./structure-AGZG422P.js"),
    locales: { fr: () => import("./fr-CIQYORPM.js") }
  },
  "b-meter-pl4": {
    structure: () => import("./structure-WPMPR7MQ.js"),
    locales: { fr: () => import("./fr-W43WFD7Q.js") }
  },
  "cgr-5502": {
    structure: () => import("./structure-GNJR4X7A.js"),
    locales: { fr: () => import("./fr-4HWUCDW5.js") }
  },
  "cgr-5505": {
    structure: () => import("./structure-X735XXHU.js"),
    locales: { fr: () => import("./fr-LEXVLCYC.js") }
  },
  "cgr-5507": {
    structure: () => import("./structure-SQFKFZYJ.js"),
    locales: { fr: () => import("./fr-AXEVNCTO.js") }
  },
  // Retired profile, kept for the installations already on it: the Narval guide it was split into, under
  // its original title, intro and compatibility.
  cyble: {
    structure: () => import("./structure-3JKUUNRU.js").then(({ default: guide }) => ({
      default: { ...guide, slug: "cyble" }
    })),
    locales: {
      fr: () => Promise.all([import("./fr-IW4I5BJN.js"), import("./fr-GLROIDE6.js")]).then(
        ([narval, cyble]) => ({ default: { ...narval.default, ...cyble.default } })
      )
    }
  },
  "cyble-dock": {
    structure: () => import("./structure-CNTQGSMY.js"),
    locales: { fr: () => import("./fr-6T75Z3YS.js") }
  },
  "diehl-dock": {
    structure: () => import("./structure-ELC4D3F5.js"),
    locales: { fr: () => import("./fr-VVIUQDRZ.js") }
  },
  "diehl-izar": {
    structure: () => import("./structure-4XN2YUTL.js"),
    locales: { fr: () => import("./fr-53QBB2XK.js") }
  },
  "diehl-hydrus": {
    structure: () => import("./structure-F7N3HV5F.js"),
    locales: { fr: () => import("./fr-JRKURGON.js") }
  },
  "datalogger-only": {
    structure: () => import("./structure-XWFNTPNR.js"),
    locales: { fr: () => import("./fr-NHCVB6HF.js") }
  },
  "debimetre-eh": {
    structure: () => import("./structure-ZQLRB7NL.js"),
    locales: { fr: () => import("./fr-4W6QRLAD.js") }
  },
  "debimetre-eh-ot-metric": {
    structure: () => import("./structure-F2MXIFNM.js"),
    locales: { fr: () => import("./fr-2T6SPON6.js") }
  },
  "debimetre-eh-promag-30": {
    structure: () => import("./structure-CKEB6B7V.js"),
    locales: { fr: () => import("./fr-LJEDQITD.js") }
  },
  "elster-pr6-v200": {
    structure: () => import("./structure-4OVZZLW2.js"),
    locales: { fr: () => import("./fr-CFE5JP7X.js") }
  },
  "fuji-modmag": {
    structure: () => import("./structure-PTILSHEQ.js"),
    locales: { fr: () => import("./fr-UZHKXHGN.js") }
  },
  "isma-dlk-102": {
    structure: () => import("./structure-UWB3ETAG.js"),
    locales: { fr: () => import("./fr-BMQJ5TNO.js") }
  },
  "itron-aquadis": {
    structure: () => import("./structure-6OSLVTXI.js"),
    locales: { fr: () => import("./fr-RFZHJRIB.js") }
  },
  "itron-flodis": {
    structure: () => import("./structure-A5QJV4EI.js"),
    locales: { fr: () => import("./fr-43QLROCJ.js") }
  },
  "itron-flostar": {
    structure: () => import("./structure-PUB6EC7F.js"),
    locales: { fr: () => import("./fr-ZLVVIFMW.js") }
  },
  "itron-narval": {
    structure: () => import("./structure-3JKUUNRU.js"),
    locales: { fr: () => import("./fr-IW4I5BJN.js") }
  },
  "kamstrup-pulse-adapter": {
    structure: () => import("./structure-7XRNL766.js"),
    locales: { fr: () => import("./fr-2MZKTJUB.js") }
  },
  "krohne-ifc100": {
    structure: () => import("./structure-HXWHKHVK.js"),
    locales: { fr: () => import("./fr-EL5DZAWY.js") }
  },
  "krohne-ifc100-configured": {
    structure: () => import("./structure-5CZLHSFC.js"),
    locales: { fr: () => import("./fr-OEC5UJHX.js") }
  },
  "krohne-ifc100-copyconfig": {
    structure: () => import("./structure-SWMKJEX3.js"),
    locales: { fr: () => import("./fr-D4I46G5Q.js") }
  },
  "krohne-ifc100-otmetric": {
    structure: () => import("./structure-NCB37SWS.js"),
    locales: { fr: () => import("./fr-XHDAMVFS.js") }
  },
  "maddalena-reed-sjplus": {
    structure: () => import("./structure-VBRSELXC.js"),
    locales: { fr: () => import("./fr-CYVKEEXI.js") }
  },
  "maddalena-flowpulse-wmap-evo": {
    structure: () => import("./structure-MQEH35BB.js"),
    locales: { fr: () => import("./fr-ZSNXOVEK.js") }
  },
  "maddalena-flowpulse-mvm": {
    structure: () => import("./structure-5OY76ISC.js"),
    locales: { fr: () => import("./fr-27A4RMOT.js") }
  },
  "maddalena-reed-one": {
    structure: () => import("./structure-IANRPA7Y.js"),
    locales: { fr: () => import("./fr-TYYXFD4L.js") }
  },
  "maddalena-reed-wmap": {
    structure: () => import("./structure-OGWNQ6QI.js"),
    locales: { fr: () => import("./fr-TAH2VAKM.js") }
  },
  "octave-arad": {
    structure: () => import("./structure-2UWGVEIV.js"),
    locales: { fr: () => import("./fr-5J2CNF7J.js") }
  },
  "ot-metric": {
    structure: () => import("./structure-A7HZS2BO.js"),
    locales: { fr: () => import("./fr-NXY2A6BO.js") }
  },
  "sensus-hri": {
    structure: () => import("./structure-AYKBDGWJ.js"),
    locales: { fr: () => import("./fr-EHPUDZ5Y.js") }
  },
  "sensus-hri-mei": {
    structure: () => import("./structure-QH4WG4KF.js"),
    locales: { fr: () => import("./fr-YYM5QCR4.js") }
  },
  "siemens-fmt020": {
    structure: () => import("./structure-765BFDXH.js"),
    locales: { fr: () => import("./fr-AQD7TU4M.js") }
  },
  "siemens-mag-5000-6000": {
    structure: () => import("./structure-CA4JSGPS.js"),
    locales: { fr: () => import("./fr-4QH5VX7U.js") }
  },
  "zenner-edc-s": {
    structure: () => import("./structure-B3PGXRY4.js"),
    locales: { fr: () => import("./fr-75KILYGC.js") }
  },
  "zenner-mtk": {
    structure: () => import("./structure-KGPGG4WQ.js"),
    locales: { fr: () => import("./fr-WAFZ27OR.js") }
  },
  "zenner-multipulse": {
    structure: () => import("./structure-3CAYW6AQ.js"),
    locales: { fr: () => import("./fr-E35S3Z5S.js") }
  },
  "zenner-reed-woltman": {
    structure: () => import("./structure-X673437Z.js"),
    locales: { fr: () => import("./fr-BUH45CV3.js") }
  }
};
var GUIDE_SLUGS = Object.keys(GUIDE_MODULES);
var isGuideSlug = (profile) => profile in GUIDE_MODULES;
var SHARED_STRINGS = {
  fr: flattenStrings(shared_default, "shared")
};
var EFENTO_SHARED = {
  fr: flattenStrings(efento_default.shared, "shared")
};
var EFENTO_BY_SLUG = { fr: efento_default };
var efentoStrings = (slug, locale) => ({
  ...EFENTO_SHARED[locale],
  ...flattenStrings(EFENTO_BY_SLUG[locale][slug])
});
var loadGuideBySlug = async (slug, locale, variant) => {
  const module = GUIDE_MODULES[slug];
  const [structure, prose] = await Promise.all([module.structure(), module.locales[locale]()]);
  return {
    guide: applyLoggerVariant(structure.default, slug, variant),
    strings: makeGuideStrings({
      ...SHARED_STRINGS[locale],
      ...flattenStrings(prose.default),
      ...variant === "efento" ? efentoStrings(slug, locale) : {}
    })
  };
};
var loadGuide = (profile, locale, variant) => isGuideSlug(profile) ? loadGuideBySlug(profile, locale, variant) : null;

// src/schema.ts
var LOGGER_VARIANTS = ["default", "efento"];
var PREREQ_SOURCE_KEY = {
  kit: "shared.prereqs.supplied",
  bring: "shared.prereqs.bring"
};
var GUIDE_LOCALES = ["fr"];
export {
  ASSET_KEYS,
  GUIDE_LOCALES,
  GUIDE_SLUGS,
  LOGGER_VARIANTS,
  PREREQ_SOURCE_KEY,
  READING_MAX_DIGITS,
  defineGuide,
  formatReading,
  indexCaptureOf,
  isCorrection,
  isGuideSlug,
  loadGuide,
  loadGuideBySlug,
  loggerVariant,
  loggerVariantForMaker,
  parseReading,
  parseRichText,
  readingValue
};
//# sourceMappingURL=index.js.map